import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { CreateNpsAnswer, FiltersNpsAnswers } from '@/Network/Types/Requests/NpsRequests'
import {
  NpsAnswerResponse,
  NpsAnswerDetailResponse,
  ListNpsAnswersResponse,
  ListNpsSubmissionsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsAnswerService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/answers'
  }

  async create(payload: CreateNpsAnswer): Promise<NpsAnswerResponse> {
    const response = await request.post<NpsAnswerResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async getById(answerId: number): Promise<NpsAnswerDetailResponse> {
    const response = await request.get<NpsAnswerDetailResponse>(
      `${this.getCompletePath()}/${answerId}`
    )
    return response.data
  }

  async list(filters?: FiltersNpsAnswers): Promise<ListNpsAnswersResponse> {
    try {
      const { data } = await request.get<ListNpsAnswersResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }

  async listSubmissions(filters?: FiltersNpsAnswers): Promise<ListNpsSubmissionsResponse> {
    try {
      const { data } = await request.get<ListNpsSubmissionsResponse>(
        `${this.getCompletePath()}/submissions`,
        filters
      )
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
